
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ucl-arc",
      function () {
        return require("private-next-pages/ucl-arc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ucl-arc"])
      });
    }
  